import React from 'react';

import { LogoPayPoPayU } from '../../../assets/images';

import LinksList from './LinksList';

import {
    NavbarSection,
    NavbarSectionContent,
    LogoBox,
} from './styles';

const Navbar = ({ config, sticky = false }) => {
    const { navigationLinks } = config;

    return (
        <NavbarSection isSticky={ sticky }>
            <NavbarSectionContent>
                <LogoBox>
                    <LogoPayPoPayU />
                </LogoBox>
                {
                    navigationLinks &&
                    <LinksList links={ navigationLinks } />
                }
            </NavbarSectionContent>
        </NavbarSection>
    );
};

export default Navbar;
